export const visit = (vm, at) => {
vm(require("timezone-utils/lang/en.lyaml"));
vm(require("ui-addon-i18n/lang/en.lyaml"));
vm(require("UIComponents/lang/en.lyaml"));
vm(require("MeetingsLib/lang/en.lyaml"));
vm(require("sanitize-text/lang/en.lyaml"));
vm(require("I18n/lang/en.lyaml"));
at({ "en": { "placeholderString": "Meetings" } });
};